import React from "react";
import DeleteIcon from "@material-ui/icons/Delete";
import { InputAdornment, TextField, IconButton } from "@material-ui/core";

export default ({ placeholder, label, values, onChange, onDelete }) => {
  const addEmpty = !values.length || values[values.length - 1];
  const adjustedValues = addEmpty ? [...values, ""] : values;
  return adjustedValues.map((val, i) => (
    <div key={i}>
      <TextField
        label={i === 0 ? label : undefined}
        onChange={({ target: { value } }) => onChange(value, i)}
        value={val}
        placeholder={placeholder}
        margin="dense"
        autoCapitalize="none"
        fullWidth
        InputProps={{
          endAdornment:
            addEmpty && i === adjustedValues.length - 1 ? (
              undefined
            ) : (
              <InputAdornment position="end">
                <IconButton size="small" onClick={() => onDelete(i)}>
                  <DeleteIcon fontSize="inherit" />
                </IconButton>
              </InputAdornment>
            )
        }}
        InputLabelProps={{ shrink: true }}
      />
    </div>
  ));
};

export const MultiTextValuePathField = ({ placeholder, label, values, onChange, onDelete }) => {
  const addEmpty = !values.length ||(values[values.length - 1].path || values[values.length - 1].path);
  const adjustedValues = addEmpty ? [...values, { path: "", value: "" }] : values;
  return adjustedValues.map((val, i) => (
    <div key={i}>
      <TextField
        onChange={({ target: { value } }) => onChange({ ...val, path: value }, i)}
        value={val.path}
        placeholder={'path'}
        margin="dense"
        autoCapitalize="none"
        style={{width: '45%', marginRight: '5%'}}
        InputProps={{
          endAdornment:
            addEmpty && i === adjustedValues.length - 1 ? (
              undefined
            ) : (
              <InputAdornment position="end">
                <IconButton size="small" onClick={() => onDelete(i)}>
                  <DeleteIcon fontSize="inherit" />
                </IconButton>
              </InputAdornment>
            )
        }}
        InputLabelProps={{ shrink: true }}
      />
      <TextField
        onChange={({ target: { value } }) => onChange({ ...val, value }, i)}
        value={val.value}
        placeholder={'value'}
        margin="dense"
        autoCapitalize="none"
        style={{width: '50%', marginRight: '0%'}}
        InputProps={{
          endAdornment:
            addEmpty && i === adjustedValues.length - 1 ? (
              undefined
            ) : (
              <InputAdornment position="end">
                <IconButton size="small" onClick={() => onDelete(i)}>
                  <DeleteIcon fontSize="inherit" />
                </IconButton>
              </InputAdornment>
            )
        }}
        InputLabelProps={{ shrink: true }}
      />
    </div>
  ));
};
